export default __webpack_public_path__ + "static/media/church-2.5443486d.jpg";